class StaffDirectoryCustomRender {
    static customRender(item)
    {
        item.isStaffAvailable = false;

        if (item.phone || item.email || item.officeRoomNum ){
            item.isStaffAvailable = true;
        }
        return item;
    }
}
export default StaffDirectoryCustomRender